<template>
    <div class="ai-parameter-custom-input">
        <RedesignFormLabel
            :label="$t('common.addCustomParameter')"
            class="mb-2"
        />
        <RedesignTagMultiInput
            ref="tagMultiInputRef"
            :tags="customParameters"
            :placeholder="$t('common.addCustomParameter')"
            :showList="showList"
            class="redesign-tag-multi-input"
            @add="handleAdd"
            @remove="handleRemove"
        />
    </div>
</template>

<script setup lang="ts">
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import RedesignTagMultiInput from '@/components/RedesignBaseComponents/Inputs/RedesignTagMultiInput.vue'

export interface ParameterOption {
    label: string
    value: string
}

export interface ParameterGroup {
    label: string
    options: ParameterOption[]
}

/* Props */
const props = withDefaults(defineProps<{
    customParameters: ParameterOption[]
    parameterGroups?: ParameterGroup[]
    showList?: boolean
}>(), {
    parameterGroups: () => [],
    showList: true
})

/* Emits */
const emit = defineEmits<{
    (e: 'add', param: ParameterOption): void
    (e: 'remove', param: ParameterOption): void
}>()

/* Methods */
function handleAdd (value: string) {
    // Check if parameter already exists in custom parameters
    const existsInCustom = props.customParameters.some(p => p.value === value)
    if (existsInCustom) return

    // Check if parameter already exists in provided groups
    const existsInGroups = props.parameterGroups.some(
        g => g.options.some(o => o.value === value)
    )
    if (existsInGroups) return

    emit('add', {
        label: value,
        value: value
    })
}

function handleRemove (value: string) {
    emit('remove', {
        label: value,
        value: value
    })
}
</script>

<style lang="scss" scoped>
.ai-parameter-custom-input {
    max-width: 400px;

    .redesign-tag-multi-input {
        max-width: 360px;
    }

    :deep(.redesign-base-input) {
        flex: 1;
    }
}
</style>
